/***
*
*   TOAST
*   A succinct notification message that is displayed temporarily.
*
*   DOCS
*   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/toast
*   https://ui.shadcn.com/docs/components/toast
*
**********/

import { forwardRef } from'react';
import * as ToastPrimitives from '@radix-ui/react-toast'
import { Icon, cn } from 'components/lib'
import { Variants } from './toast.tailwind.js'

const ToastProvider = ToastPrimitives.Provider

const ToastViewport = forwardRef(({ className, ...props }, ref) => (

  <ToastPrimitives.Viewport ref={ ref } className={ cn('fixed top-0 z-[1002] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]', className) } {...props }/>

))

ToastViewport.displayName = ToastPrimitives.Viewport.displayName

const Toast = forwardRef(({ className, variant, ...props }, ref) => {

  return <ToastPrimitives.Root ref={ ref } className={ cn(Variants({ variant }), className) }  {...props } />

})

Toast.displayName = ToastPrimitives.Root.displayName

const ToastAction = forwardRef(({ className, ...props }, ref) => (

  <ToastPrimitives.Action ref={ ref } className={ cn('inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-slate-200 bg-transparent px-3 font-medium ring-offset-white transition-colors hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.error]:border-slate-100/40 group-[.error]:hover:border-red-400 group-[.error]:hover:bg-red-500 group-[.error]:hover:text-slate-50 group-[.error]:focus:ring-red-500 dark:border-slate-800 dark:ring-offset-slate-950 dark:hover:bg-slate-800 dark:focus:ring-slate-300 dark:group-[.error]:border-slate-800/40 dark:group-[.error]:hover:border-red-900/30 dark:group-[.error]:hover:bg-red-900 dark:group-[.error]:hover:text-slate-50 dark:group-[.error]:focus:ring-red-900', className )} {...props }/>

))

ToastAction.displayName = ToastPrimitives.Action.displayName

const ToastClose = forwardRef(({ className, ...props }, ref) => (

  <ToastPrimitives.Close ref={ ref } className={ cn('self-start opacity-70 hover:opacity-100 transition-opacity duration-200 p-1 rounded-md hover:bg-white/10', className) } toast-close='' {...props }>
    <Icon name='x' className='h-4 w-4 text-white/80'/>
  </ToastPrimitives.Close>

))

ToastClose.displayName = ToastPrimitives.Close.displayName

const ToastTitle = forwardRef(({ className, ...props }, ref) => (

  <ToastPrimitives.Title ref={ ref } className={ cn('font-semibold', className) } {...props } />

))

ToastTitle.displayName = ToastPrimitives.Title.displayName

const ToastDescription = forwardRef(({ className, ...props }, ref) => (

  <ToastPrimitives.Description ref={ ref } className={ cn(className) } {...props }/>

))

ToastDescription.displayName = ToastPrimitives.Description.displayName

export { ToastProvider, ToastViewport, Toast, ToastTitle, ToastDescription, ToastClose, ToastAction };
